import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'website',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: '#1D4ED8',
  glyph: [{ d: 'M3 4h18v16H3z' }, { d: 'M3 9h18M8 9v11' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: ['app.records.read', 'app.records.write', 'external.productions.read'],
    defines: [],
  },
  entities: {
    uses: [],
    owns: ['plans', 'reports', 'history', 'receipts'].map((table) => ({
      table,
      scope: 'workspace' as const,
      description: fr.description,
    })),
  },
  events: {
    emits: emitsOf(events),
    subscribes: [],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['website.seed'], conditions: ['website.completed'], blocks: [] },
  migrations: { schema: 'app_website', dir: 'migrations' },
});
